import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCodeRoute: InvariantJiraRoute = {
	name: 'software-code',
	path: '/jira/software/projects/:projectKey/code',
};
